export default __webpack_public_path__ + "img/bXJDMFGC.fd6b911c.svg";